// @flow
import { combineReducers } from "redux";
import absenceRate, { initialState as absenceRateInitialState } from "./absence-rate";
import compliance, { initialState as complianceInitialState } from "./compliance";
import slaPerformance, { initialState as slaPerformanceInitialState } from "./sla-performance";
import absenceReason, { initialState as absenceReasonInitialState } from "./absence-reason";

export const initialState = {
  absenceRate: absenceRateInitialState,
  compliance: complianceInitialState,
  slaPerformance: slaPerformanceInitialState,
  absenceReason: absenceReasonInitialState,
};

export default combineReducers({
  absenceRate,
  compliance,
  slaPerformance,
  absenceReason,
});
